<template>
    <card-sections
        :title="Lang.get('employerdashboard::pages/settings/two-factor-authentication.title')"
        :subtitle="Lang.get('employerdashboard::pages/settings/two-factor-authentication.subtitle')"
        tabName="two-factor-authentication"
        :hideMsg="true"
    >
        <form @submit.prevent="submit()">
            <p class="font-poppins font-weight-light color-dark-blue">
                {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.connect.heading') }}
            </p>
            <div class="row">
                <div class="form-group col-12 col-md-4 mb-4">
                    <div v-html="secret.qr_code"></div>
                </div>
                <div class="form-group col-12 col-md-8 mb-4">
                    <p class="font-poppins font-weight-light color-dark-blue">
                        {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.connect.alternative_options.explanation.before_code') }}
                        <strong>
                            {{ secret.string}}
                        </strong>
                        {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.connect.alternative_options.explanation.after_code') }}
                    </p>
                    <p>
                        <a class="btn btn-info" :href="secret.uri">
                            {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.connect.alternative_options.otpauth_button_label') }}
                        </a>
                    </p>
                </div>
            </div>
            <p class="font-poppins font-weight-light color-dark-blue">
                {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.connect.code_explanation') }}
            </p>
            <div class="row">
                <div class="form-group col-12 col-md-4 mb-4">
                    <text-input
                        v-model="form.confirmation_code"
                        :label="Lang.get('employerdashboard::pages/settings/two-factor-authentication.connect.code')"
                        :placeholder="Lang.get('employerdashboard::pages/settings/two-factor-authentication.connect.code')"
                        :error="errors.confirmation_code"
                    />
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-md-4">
                    <button
                        type="submit"
                        :disabled="!canSubmit"
                        class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4">
                        {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.connect.button') }}
                    </button>
                </div>
            </div>
        </form>
    </card-sections>
</template>

<script>
import CardSections from "@/Pages/Settings/Shared/CardSections";
import TextInput from "@/Shared/TextInput";

export default {
    components: {
        CardSections,
        TextInput,
    },
    props: {
        errors: Object,
        secret: Object,
    },
    data() {
        return {
            form: {
                confirmation_code: '',
            },
        }
    },
    computed: {
        canSubmit() {
            return this.form.confirmation_code.length === 6;
        },
    },
    methods: {
        submit() {
            this.$inertia.post(
                this.route(
                    'nl.employerdashboard.settings.two-factor-authentication.connect',
                    this.$page.props.auth.user.selected_company.uuid
                ),
                this.form,
            );
        },
    },
}
</script>
